import exampleToRepo from "~/components/pipeline/New/ConnectGitPicker/util/exampleToRepo";
import type { Example } from "~/components/shared/Examples/useExamples";
import type {
  SCMServiceInfo,
  RepositoryInfo,
} from "~/components/pipeline/New/ConnectGitPicker/util/types";

export async function fetchRepositories(
  service: SCMServiceInfo,
  search: string,
  signal?: AbortSignal,
): Promise<RepositoryInfo[]> {
  if (!service?.repositories_url) {
    return [];
  }

  let url = service.repositories_url;
  if (search && service.uuid !== "examples") {
    url += `?search=${encodeURIComponent(search)}`;
  }

  const response = await fetch(url, {
    signal,
    headers: { "X-Buildkite-Frontend-Version": BUILDKITE_FRONTEND_VERSION },
  });

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }

  const data: RepositoryInfo[] | Example[] = await response.json();

  return service.uuid === "examples"
    ? exampleToRepo(data as Example[])
    : (data as RepositoryInfo[]);
}
